module.exports = __webpack_public_path__ + "img/73.9e784413.jpg";